angular.module('app')

	.controller('ProductDetailController', ['$scope', '$timeout', '$state', function ProductDetailController ($scope, $timeout, $state)
	{
		var productDetail = this;
		productDetail.productId = $state.params.id;
		var productDetailPage = document.getElementById('product_detail_page');
	}]);
